/** The transport and persistence remain the responsibility of each form. */
export function initListingPhotoDropzone({ input, dropzone, addFiles, isBusy = () => input.disabled }) {
    const accept = files => { if (!isBusy()) addFiles(Array.from(files || [])); };
    input.addEventListener('change', () => { accept(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(type => dropzone.addEventListener(type, event => {
        event.preventDefault();
        if (!isBusy()) dropzone.classList.add('is-dragover');
    }));
    ['dragleave', 'drop'].forEach(type => dropzone.addEventListener(type, event => {
        event.preventDefault();
        dropzone.classList.remove('is-dragover');
    }));
    dropzone.addEventListener('drop', event => accept(event.dataTransfer?.files));
}
